<template>
  <div>
    <LabelledInput
      v-if="customPageTitle"
      data-test="labelled-input-custom-title"
      label="Custom Page Title"
    >
      <b-textarea
        v-model="globalPageTitle"
        data-test="input-global-page-title"
      />
    </LabelledInput>

    <LabelledInput
      v-if="customPageDescription"
      data-test="labelled-input-custom-description"
      label="Custom Page Description"
    >
      <b-textarea
        v-model="globalPageDescription"
        data-test="input-global-page-description"
      />
    </LabelledInput>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import { APP_CONFIG_KEY } from '@/constants'
import { AppConfig } from '@/types'

const components = {
  LabelledInput,
}

@Component({ components })
export default class GlobalPageTitleDescriptionSettings extends Vue {
  get customPageTitle () {
    return this.$typedStore.primary.app.config.appConfig.customPageTitle ?? false
  }

  get customPageDescription () {
    return this.$typedStore.primary.app.config.appConfig.customPageDescription ?? false
  }

  get globalPageTitle () {
    return this.$typedStore.primary.app.config.appConfig.pageTitle ?? ''
  }

  set globalPageTitle (value) {
    this.updateConfig(value, 'pageTitle')
  }

  get globalPageDescription () {
    return this.$typedStore.primary.app.config.appConfig.pageDescription ?? ''
  }

  set globalPageDescription (value) {
    this.updateConfig(value, 'pageDescription')
  }

  updateConfig (value: boolean | string, ...args: [keyof Pick<AppConfig, 'pageTitle' | 'pageDescription'>]) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [APP_CONFIG_KEY, ...args],
      value,
    })
  }
}

</script>
